import { toArray } from '@nrk/dh-utils'
import { closest } from '@nrk/dh-basis-common'

export default class TilpassetBilde extends HTMLElement {
  connectedCallback() {
    if (this._isFullWidth() || this._isFeatureCover() || this._isDhFullWidth()) {
      const sources = toArray(this.querySelectorAll('source'))
      sources.forEach((source) => {
        source.setAttribute('sizes', '100vw')
      })
    }
  }

  _isFullWidth() {
    const remoterendered = closest(
      this,
      '.remoterenderedcontent-reference,.inlinesanitycontent-reference'
    )
    return remoterendered && remoterendered.classList.contains('fc')
  }

  _isFeatureCover() {
    const cover = closest(this, '.article-feature__cover')
    return !!cover
  }

  _isDhFullWidth() {
    return !!closest(this, '.dh-fullbredde')
  }
}
